// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button-module--btn--3VOUW","primary":"Button-module--primary--25-G6","default":"Button-module--default--2CL7M"};